import { Component, OnInit, ViewChild } from '@angular/core';
import { AmorphicService } from '../../services/amorphic/amorphic.service';
import { BaseLoginService } from '../../services/login/base-login.service';
import { BasicTextInputComponent } from '../form/base-components/base-text-input/basic-text-input.component';
import { AuthenticatingController } from '../../../../common/js/AuthenticatingController';

@Component({
  moduleId: module.id,
  selector: 'account-settings',
  templateUrl: './account-settings.component.html',
})
export class AccountSettingsComponent implements OnInit {
  controller: AuthenticatingController;
  resetConfirm: boolean;
  displayEmail: string;
  newEmail: string;
  error: string;
  passwordError: string;
  emailResetIsRequested: boolean;
  useAmc: boolean;
  passwordChanged: boolean;
  @ViewChild('settingsPassword') settingsPassword: BasicTextInputComponent;
  @ViewChild('settingsNewPassword') settingsNewPassword: BasicTextInputComponent;
  @ViewChild('settingsEmail') settingsEmail: BasicTextInputComponent;

  constructor(private amorphicService: AmorphicService, private loginService: BaseLoginService) {
    this.controller = amorphicService.controller as unknown as AuthenticatingController;
    this.useAmc = this.controller.isAuth0Enabled;
  }

  ngOnInit(): void {
    this.resetConfirm = false;
    this.displayEmail = this.controller.email;
    this.newEmail = '';
    this.emailResetIsRequested = false;
    this.passwordChanged = false;
    this.error = '';
    this.passwordError = '';
  }

  resetEmail(): void {
    this.error = '';
    this.newEmail = this.controller.newEmail;
    this.loginService
      .resetEmail(document.location.href)
      .then(() => {
        this.emailResetIsRequested = true;
        this.settingsPassword.val = '';
      })
      .catch((error) => {
        if (error.code === 'email_registered') {
          this.error = error.text;
        } else if (error.code === 'invalid_email_or_password') {
          this.error = error.text;
        }
      });
  }

  resetPassword(): void {
    this.loginService
      .resetPassword(document.location.href)
      .then(() => {
        this.resetConfirm = true;
        if (this.useAmc) {
          this.passwordChanged = true;
          this.clearPasswords();
        }
      })
      .catch((error) => {
        if (error.code === 'invalid_email_or_password') {
          this.passwordError = error.text;
        }
      });
  }

  clearPasswords() {
    this.settingsPassword.val = '';
    this.settingsNewPassword.val = '';
  }

  onEmailChanged() {
    this.controller.newEmail = this.settingsEmail.val;
  }
}
